import { AssignmentModel } from './AssignmentModel';
import { ClientModel } from './ClientModel';
export class CreateAssignmentRequestModel {
  region : string;
  client: ClientModel;
  assignments: AssignmentModel[];
}
